var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncheckedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.3999V6.59995V6.59625C21 5.33859 21 4.70938 20.755 4.22855C20.5393 3.80518 20.1946 3.46095 19.7713 3.24524C19.29 3 18.6603 3 17.4002 3H6.60022C5.3401 3 4.70957 3 4.22827 3.24524C3.80491 3.46095 3.46095 3.80518 3.24524 4.22855C3 4.70985 3 5.33983 3 6.59995V17.3999C3 18.6601 3 19.2902 3.24524 19.7715C3.46095 20.1949 3.80491 20.539 4.22827 20.7547C4.70957 21 5.3401 21 6.60022 21H17.4002C18.6603 21 19.29 21 19.7713 20.7547C20.1946 20.539 20.5393 20.1949 20.755 19.7715C21 19.2907 21 18.6613 21 17.4036V17.3999Z",
    fill: "#242633",
    stroke: "#424659",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedDark);
export default __webpack_public_path__ + "static/media/uncheckedDark.fa2a2a5858d6f8a4df06500ad5d61665.svg";
export { ForwardRef as ReactComponent };